import apiProvider from './utilities/provider'

const url = 'offer-letters'

const apiOfferLetters = {
  getCandidateResponseContext: (apiKey) =>
    apiProvider.getSingle(url, `candidate-response/${apiKey}`),

  submitCandidateResponse: (apiKey, data) =>
    apiProvider.post(`${url}/candidate-response/${apiKey}`, data),
}

export default apiOfferLetters
